import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography/Typography";
import { esGestiona } from "@portal/arq-portal-core";
import React from "react";
import { Producto } from "./Producto";

const useStylesMasonry = makeStyles({
    productoFila: {
        margin: '10px 0',
        borderBottom: '2px solid #d6d8d8',
        paddingBottom: '10px'
    },
    productoEnlace: {
        color: '#dc0028',
        fontWeight: 'bold',
        fontSize: '14px'
    },
    lista_show3: {
        columnCount: 3,
        columnGap: '2rem',
        marginTop: '.5rem',
        '@media screen and (max-width: 959px)': {
            columnCount: 1
        }
    },
    lista_show2: {
        columnCount: 2,
        columnGap: '2rem',
        marginTop: '.5rem',
        '@media screen and (max-width: 959px)': {
            columnCount: 1
        }
    },
    producto: {
        backgroundColor: "#FFFFFF",
        padding: "15px",
        margin: "10px 0px 25px 0px"
    },
    item25MB: { 
        marginBottom: `25px`
    },
    item0ML: { 
        marginLeft: `0px`,
        flex: 1
    },
    item25ML: { 
        marginLeft: `25px`,
        flex: 1,
        '@media screen and (max-width: 959px)': {
            marginLeft: `0px`
        }
    },
    massonryContainer: { 
        display: 'flex',
        '@media screen and (max-width: 959px)': {
            display: `block`
        }
    }
});

export const ProductosAgrupados = ({productos,cia,favs}: any) => {
    
    const clases = useStylesMasonry();
    
    return (
        <React.Fragment>
            <div className={clases.massonryContainer}>
                {
                    Object.entries(productos).map( (grupoCol: any, index: number) => {
                        let gruposOrdenados = Object.entries(grupoCol[1]).sort( (a:any, b:any) => a.order - b.order );
                        return (
                            <div className={index > 0 ? clases.item25ML : clases.item0ML}>
                                {
                                    gruposOrdenados.map( (grupo: any) => {
                                        let [title, { items }] = grupo;
                                        return (
                                            <div className={clases.producto}>
                                                <div className={clases.productoFila}>
                                                    <Typography variant='caption' className={clases.productoEnlace}>{title}</Typography>
                                                </div>
                                                <div className={ (esGestiona() && cia === "SPU")?  clases.lista_show2: clases.lista_show3 }>
                                                    { items.map( (producto:any) => <Producto producto={producto} favs={favs}/> ) }
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    })
                }
            </div>
        </React.Fragment>
    );
}
